import axios from "axios";
import React, {useEffect, useState, Fragment} from "react";
import {useParams} from "react-router-dom";
import clientconfigwebapp, {
    empty_bk, convert_to_english_strhk, check_login_appbk, Token_get_appbk, redirectbh_typeb,
} from '../../../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';
import Grid from '@mui/material/Grid';


const Authentication_Documents_Tab2 = (props) => {
    const { Data_Full_Get, setActiveTabCurrent } = props;

    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");


    /*  start code file_upload  */
    const [file, setFile] = React.useState();
    const [file_name_get, set_file_name] = React.useState('');
    const uploadRef = React.useRef();
    const statusRef = React.useRef();
    const loadTotalRef = React.useRef();
    const progressRef = React.useRef();
    const [attach_file_get_2, set_attach_file_2] = useState('');
    const [show_hide_pogressbar, setshow_hide_pogressbar] = useState('none');
    const [uploadUrl, setUploadUrl] = useState('')
    /*  endddd code file_upload  */




    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setUploadUrl(URL.createObjectURL(file));
        document.querySelector(`#${e.target.ariaLabel}`).classList.toggle('image_up_act_2');

        UploadFile_start();
    }
    const deleteUploadBg = (e) => {
        if (uploadUrl !== '') {
            setUploadUrl('');
            document.querySelector(`#${e.target.ariaLabel}`).classList.toggle('image_up_act_2');
        }

        set_attach_file_2('');
    }


    const UploadFile_start = () => {
        const file = uploadRef.current.files[0];
        console.log(file, "filefilefile");
        ///// setFile(URL.createObjectURL(file));
        setFile(URL.createObjectURL(file));
        set_file_name(file.name);
        var formData = new FormData();
        formData.append("fileattach", file);
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", ProgressHandler, false);
        xhr.addEventListener("load", SuccessHandler, false);
        xhr.addEventListener("error", ErrorHandler, false);
        xhr.addEventListener("abort", AbortHandler, false);
        xhr.open("POST", String(clientconfigwebapp.host_dl_get) + "upload-documents-b.php");
        xhr.send(formData);


    };

    const ProgressHandler = (e) => {
        set_attach_file_2("");
        setshow_hide_pogressbar("flex");
        /// loadTotalRef.current.innerHTML = `uploaded ${e.loaded} bytes of ${e.total}`;
        var percent = (e.loaded / e.total) * 100;
        progressRef.current.value = Math.round(percent);
        ///statusRef.current.innerHTML = Math.round(percent) + "% uploaded...";
        statusRef.current.innerHTML = Math.round(percent) + "%";
    };

    const SuccessHandler = (e) => {
        set_attach_file_2("");
        var respons_get = e.target.response;

        ///  statusRef.current.innerHTML = e.target.responseText;
        progressRef.current.value = 0;
        statusRef.current.innerHTML = "0%";

        ///  setshow_hide_pogressbar("flex");

        console.log(respons_get, "respons_get");

        console.log(respons_get,"respons_get_jsonfile_name_get")

        if (String(respons_get).length > 0) {

            var respons_get_json = JSON.parse(respons_get);



            if (String(respons_get_json.data).length > 0) {


                if (String(respons_get_json.data) == "success" && !empty_bk(String(respons_get_json.file_name_get))) {

                    // let attach_file_get_2 = document.getElementById('attach_file_get_2');
                    // if (attach_file_get_2 != null) {
                    //     attach_file_get_2.value=String(respons_get_json.file_name_get);
                    // }

                    set_attach_file_2(String(respons_get_json.file_name_get));
                    progressRef.current.value = 100;
                    statusRef.current.innerHTML = "تصویر با موفقیت آپلود شد، بر روی دکمه ارسال کلیک کنید";

                    if (String(respons_get_json.msgwebapp).length > 0) {
                        toast.success(respons_get_json.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }


                } else {


                    if (String(respons_get_json.msgwebapp).length > 0) {
                        toast.error(respons_get_json.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                }


            } else {

                if (String(respons_get_json.msgwebapp).length > 0) {
                    toast.error(respons_get_json.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }


        } else {

            toast.error("خطا در آپلود فایل کد خطا 654754", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        }


    };


    const ErrorHandler = () => {
        statusRef.current.innerHTML = "upload failed!!";
        setshow_hide_pogressbar("none");
        set_attach_file_2("");
        toast.error("خطا در ارتباط با سرور، اینترنت خود را بررسی کنید. کد خطا 345346", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const AbortHandler = () => {
        statusRef.current.innerHTML = "upload aborted!!";
        setshow_hide_pogressbar("none");
        set_attach_file_2("");
        toast.error("خطا در ارتباط با سرور، اینترنت خود را بررسی کنید. کد خطا 567567", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };




    const Handler_saved_send_aut = () => {
        if (check_login_appbk() === false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };


        let attach_file_get_1 = document.getElementById('attach_file_get_1').value;
        if (attach_file_get_1 != null) {
            if(String(attach_file_get_1).length > 0){

            }else{
                return toast.error('تصویر کارت ملی انتخاب نشده', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                })
            }

        }



        let attach_file_get_2 = document.getElementById('attach_file_get_2').value;
        if (attach_file_get_2 != null) {
            if(String(attach_file_get_2).length > 0){

            }else{
                return  toast.error('تصویر کاغذ A4 آپلود نشده', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                })
            }

        }



        Setloadinghkfullshow("true");

        let form_data = document.querySelector('#form_data_profile');
        if (form_data != null) {
            let formDatanew = new FormData(form_data);
            formDatanew.append("step", "2");
            let data_serialize = new URLSearchParams(formDatanew).toString();

            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/authentication-send-document/`, data_serialize, config)
                .then((res) => {
                    Setloadinghkfullshow("false");
                    if (String(res.data).length > 0) {
                        if (String(res.data.data) === "login-show") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                        }
                        if (String(res.data.status) === "success") {
                            setActiveTabCurrent('tab3');
                        } else {
                            if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }
                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }).catch((err) => {
                Setloadinghkfullshow("false");
                toast.error('خطا اتصال به سرور کد  6786324', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
        }
    }

    return (
        <Fragment>
            <section className=''>

                <input id={"attach_file_get_2"} type={"text"} value={attach_file_get_2} name="attach_file_get_2"
                       style={{display: "block"}}/>


                <div style={{"fontSize":"13px","display":"block","fontWeight":"bold","marginBottom":"7px"}}>
                    کارت ملی خود را روی کاغذ سفید(A۴) بچسبانید.
                </div>

                <div style={{"fontSize":"13px","display":"block","fontWeight":"bold","marginBottom":"7px"}}>
                    متن زیر را با ماژیک روی همان کاغذ نوشته و با آن عکس واضح بگیرید.
                </div>
                <div style={{color:"#01A3D4","fontSize": "12px", "display": "block", "fontWeight": "bold", "marginBottom": "19px"}}>
                    اینجانب.........کارت ملی خود را جهت احراز هویت در بازارانو ارسال می نمایم.
                </div>


                <div className='upload_box_aut_documnet_aut_wrapper'>


                    <input
                        accept="image/*"
                        style={{display: 'none'}}
                        id="image-upload_2"
                        aria-label='up_2'
                        type="file"
                        name={"fileget_2"}
                        ref={uploadRef} onChange={handleImageChange}

                    />

                    <div className='flexRowStartEnd'>
                        <label className='upload_box_documnet_aut' id='up_2'
                               htmlFor="image-upload_2"><span>
                                                 <svg width={62} height={61} viewBox="0 0 62 61" fill="none"
                                                      xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_0_3647)">
          <path
              d="M43.7083 48.8509H13.2083V17.7918H31V12.7084H13.2083C10.4125 12.7084 8.125 14.9959 8.125 17.7918V48.2918C8.125 51.0876 10.4125 53.3751 13.2083 53.3751H43.7083C46.5042 53.3751 48.7917 51.0876 48.7917 48.2918V30.5001H43.7083V48.8509Z"
              fill="#01A3D4"/>
          <path
              d="M48.7917 5.08344H43.7084V12.7084H36.0834C36.1088 12.7339 36.0834 17.7918 36.0834 17.7918H43.7084V25.3913C43.7338 25.4168 48.7917 25.3913 48.7917 25.3913V17.7918H56.4167V12.7084H48.7917V5.08344Z"
              fill="#01A3D4"/>
          <path d="M38.625 22.8751H18.2916V27.9584H38.625V22.8751Z" fill="#01A3D4"/>
          <path d="M18.2916 30.5001V35.5834H38.625V30.5001H31H18.2916Z" fill="#01A3D4"/>
          <path d="M38.625 38.1251H18.2916V43.2084H38.625V38.1251Z" fill="#01A3D4"/>
        </g>
        <defs>
          <clipPath id="clip0_0_3647">
            <rect width={61} height={61} fill="white" transform="translate(0.5)"/>
          </clipPath>
        </defs>
      </svg>
                                                </span>


                            <span>کلیک کنید و عکس را بارگذاری کنید</span>

                        </label>


                    </div>

                    <span style={{
                        "display": "block",
                        "textAlign": "left",
                        "marginBottom": "8px",
                        "fontSize": "13px",
                        "color": "#828282",
                        "fontFamily": "'iran'"
                    }}>jpg , png , jpeg </span>

                    <div style={{display: show_hide_pogressbar}}>
                        <progress ref={progressRef} value="0" max="100"
                                  style={{display: "none"}}/>
                        <span className={"pers"} ref={statusRef} style={{
                            "marginTop": "12px",
                            "lineHeight": "1.6",
                            "color": "#009688",
                            "fontWeight": "normal",
                            "fontSize": "17px",
                            "fontFamily": "'iran'",
                            "display": "block",
                            "width": "100%"
                        }}></span>
                    </div>


                </div>

                <div style={{
                    "width": "100%",
                    "display": "flex",
                    "flexDirection": "row",
                    "justifyContent": "center",
                    "alignItems": "center"
                }}>
                    <button className={"btn-bk-new btn-bk-new-blue"} type="button"
                            style={{marginTop: "10px", marginBottom: "22px", "width": "154px"}}
                            onClick={Handler_saved_send_aut}>
                        ارسال
                    </button>
                </div>


            </section>
        </Fragment>
    );
}

export default Authentication_Documents_Tab2;
